import { Dialog } from 'vant'
let lastSrcs // 上一次获取到的script地址

const scriptReg = /\<script.*src=["'](?<src>[^"']+)/gm

async function extractNewScripts () {
  const html = await fetch(window.location.href + '?_timestamp=' + Date.now()).then((resp) =>
    resp.text()
  )
  scriptReg.lastIndex = 0
  const result = []
  let match
  while ((match = scriptReg.exec(html))) {
    result.push(match.groups.src)
  }
  return result
}

async function needUpdate () {
  const newScripts = await extractNewScripts()
  if (!lastSrcs) {
    lastSrcs = newScripts
    return false
  }
  let result = false
  if (lastSrcs.length !== newScripts.length) {
    result = true
  }
  for (let i = 0; i < lastSrcs.length; i++) {
    if (lastSrcs[i] !== newScripts[i]) {
      result = true
      break
    }
  }
  lastSrcs = newScripts
  return result
}
const DURATION = 2000

function autoRefresh () {
  setTimeout(async () => {
    const willUpdate = await needUpdate()
    console.log(willUpdate)
    if (willUpdate) {
      Dialog.alert({
        title: '提示',
        message: '版本更新，点击确定刷新'
      }).then(() => {
        location.reload()
        // location.href = '/'
      })
      // const result = confirm('页面有更新')
      // if (result) {
      // 	location.reload()
      // }
    }
    autoRefresh()
  }, DURATION)
}

const NODE_ENV = process.env.NODE_ENV
if (NODE_ENV !== 'development') {
  autoRefresh()
}

// autoRefresh()
